export default function sliceObject(src, props) {
  let dest = {};
  props.forEach((x) => (dest[x] = src[x]));
  return dest;
}

